import React, { useState, useEffect } from 'react'
import Image from 'next/legacy/image'
import { ChevronDownZip, ChevronUpZip } from '@components/icons'
import styles from './index.module.css'

const ZipCards = () => {
  const [isExpandedPay, setIsExpandedPay] = useState(false)
  const [isExpandedMoney, setIsExpandedMoney] = useState(false)

  const toggleCardExpanded = () => {
    setIsExpandedPay(!isExpandedPay)
    setIsExpandedMoney(!isExpandedMoney)
  }

  // for Mobile
  const toggleCardExpandedMobile = (kind) => {
    if (kind === 'pay') {
      setIsExpandedPay(!isExpandedPay)
    } else {
      setIsExpandedMoney(!isExpandedMoney)
    }
  }

  return (
    <div className={styles.modal__third_section}>
      <div className={styles.modal__third_section_card}>
        <div className={styles.modal__most_pupular}>
          <p>Most popular</p>
        </div>
        <div className={styles.modal__card_content}>
          <Image
            width={80}
            height={25}
            src="/icons/zip-pay.svg"
            alt="Zip Pay"
            unoptimized
          />
          <p className={styles.modal__card_limit}>Up to $1,000</p>
          <p className={styles.modal__card_heading}>Interest free always</p>
          <p className={styles.modal__card_description}>
            For everyday spending, from fashion to fitness, eyewear to
            electronics, pet care to bills.
          </p>
          <a
            className={`${styles.modal__card_cta} ${styles.modal__cta_primary} ${styles.modal__product_cta}`}
            href="https://start.zip.co/?m=9dbeb1e3-263b-4991-9553-0ecc1a0fce4b"
            target="_blank"
            rel="noreferrer"
          >
            Apply now
          </a>
          {isExpandedPay && (
            <ul className={styles.modal__card_features_list}>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    Interest free always
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    Flexible repayments
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    No establishment fee
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    $9.95 monthly account fee
                  </p>
                  <p className={styles.modal__card_features_description}>
                    Pay your statement closing balance, in full, by the due date
                    and we'll waive the fee.
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    Tap to pay everywhere Visa is accepted^
                  </p>
                </div>
              </li>
            </ul>
          )}
          <button
            className={`${styles.modal__card_features_cta_desktop} text-body2 font-normal text-ui-dark-grey flex hover:cursor-pointer pt-2`}
            onClick={() => toggleCardExpanded()}
          >
            {isExpandedPay ? <ChevronUpZip /> : <ChevronDownZip />}
          </button>
          <button
            className={`${styles.modal__card_features_cta_mobile} text-body2 font-normal text-ui-dark-grey flex hover:cursor-pointer pt-2`}
            onClick={() => toggleCardExpandedMobile('pay')}
          >
            {isExpandedPay ? <ChevronUpZip /> : <ChevronDownZip />}
          </button>
        </div>
      </div>
      <div className={styles.modal__third_section_card}>
        <div className={styles.modal__card_content}>
          <Image
            width={100}
            height={25}
            src="/icons/zip-money.svg"
            alt="Zip Money"
            unoptimized
          />
          <p className={styles.modal__card_limit}>$1,000 - $50,000</p>
          <p className={styles.modal__card_heading}>Bigger purchases</p>
          <p className={styles.modal__card_description}>
            For buying that road bike, new sofa or renovating your home.
          </p>
          <a
            className={`${styles.modal__card_cta} ${styles.modal__cta_secondary} ${styles.modal__product_cta}`}
            href="https://my.zipmoney.com.au/?sso=sign-up&amp;m=9dbeb1e3-263b-4991-9553-0ecc1a0fce4b"
            target="_blank"
            rel="noreferrer"
          >
            Apply now
          </a>
          {isExpandedMoney && (
            <ul className={styles.modal__card_features_list}>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    Interest free for first 3 months
                  </p>
                  <p className={styles.modal__card_features_description}>
                    Retailers may offer longer interest free terms (6-60
                    months). At conclusion of the interest free period, interest
                    will be charged at the standard variable rate of 21.9% per
                    annum.
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    Flexible repayments
                  </p>
                  <p className={styles.modal__card_features_description}>
                    Enjoy the freedom to set your schedule to weekly,
                    fortnightly or monthly..
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    One-off establishment fee
                  </p>
                  <p className={styles.modal__card_features_description}>
                    A one-off establishment fee may apply for new customers.
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    $9.95 monthly account fee
                  </p>
                  <p className={styles.modal__card_features_description}>
                    Waived if you have nothing owing.
                  </p>
                </div>
              </li>
              <li>
                <img src="/icons/zip-bullet.svg" alt="Bullet" />
                <div className={styles.modal__card_features_content}>
                  <p className={styles.modal__card_features_title}>
                    Interest free instalment plans
                  </p>
                  <p className={styles.modal__card_features_description}>
                    For purchases over $300 we'll automatically set you up to
                    repay in equal instalments to help you avoid interest
                    charges.^^.
                  </p>
                </div>
              </li>
            </ul>
          )}
          <button
            className={`${styles.modal__card_features_cta_desktop} text-body2 font-normal text-ui-dark-grey flex hover:cursor-pointer pt-2`}
            onClick={() => toggleCardExpanded()}
          >
            {isExpandedMoney ? <ChevronUpZip /> : <ChevronDownZip />}
          </button>
          <button
            className={`${styles.modal__card_features_cta_mobile} text-body2 font-normal text-ui-dark-grey flex hover:cursor-pointer pt-2`}
            onClick={() => toggleCardExpandedMobile('money')}
          >
            {isExpandedMoney ? <ChevronUpZip /> : <ChevronDownZip />}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ZipCards
